<template>
  <app-table v-bind="$attrs" class="w-full" v-if="items.length">
    <template v-slot:table-body>
      <tr
        v-for="item in isInput ? filteredItems : filteredActivitiesBySelect"
        :key="item.actionId"
        class="border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-12 hover:bg-blue-lightest"
      >
        <td width="145px" style="min-width:145px;max-width:145px;">
          <app-document-status-indicator-provider
            :requestStatus="item.documents[0].option.viewType"
            :resultStatus="item.documents[1].option.viewType"
            :memoryStatus="item.documents[2].option.viewType"
            :documentId="item.id"
            :requestIsMine="item.documents[0].option.isMine"
            :resultIsMine="item.documents[1].option.isMine"
            :memoryIsMine="item.documents[2].option.isMine"
          ></app-document-status-indicator-provider>
        </td>
        <td
          class="pl-3"
          width="400px"
          style="max-width: 400px; word-wrap: break-word;"
        >
          <span class="text-black text-lg"
            >{{
              item.startDate
                ? dayjs(item.startDate).format('YYYY/M/D')
                : '----/--/--'
            }}
            ～
            {{
              item.endDate
                ? dayjs(item.endDate).format('YYYY/M/D')
                : '----/--/--'
            }}
          </span>
          <br />
          <span
            class="text-black text-lg"
            style=" max-height: 55px; overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 2;"
            >{{ item.place }}</span
          >
          <div class="flex flex-row items-center mt-2">
            <div>
              <span class="text-blue text-lg">{{
                dayjs(item.updatedAt).format('YYYY/M/D')
              }}</span
              ><span class="text-blue text-sm"> 更新</span>
            </div>
            <div class="ml-3">
              <div class="flex flex-row items-center">
                <user-circle-icn
                  width="20"
                  height="20"
                  class="blue-icon-user"
                ></user-circle-icn>
                <span
                  class="ml-1 text-blue"
                  :class="item.isOwn ? 'font-bold' : ''"
                  >{{ item.user.uname }}</span
                >
              </div>
            </div>
          </div>
        </td>
        <td
          class="pl-3"
          width="380px"
          style="max-width: 380px; word-wrap: break-word;"
        >
          <span
            class="text-lg"
            style="max-height: 140px; overflow: hidden; display: -webkit-box; -webkit-box-orient: vertical; -webkit-line-clamp: 3;"
          >
            {{ item.purpose }}
          </span>
        </td>
        <td width="20px" class="text-center">
          <Menu as="div" class="relative flex text-left">
            <MenuButton>
              <actions-icn
                @click="deleteApproval()"
                width="20px"
                height="20px"
                class="blue-icon"
              ></actions-icn>
            </MenuButton>
            <transition
              enter-active-class="transition duration-100 ease-out"
              enter-from-class="transform scale-95 opacity-0"
              enter-to-class="transform scale-100 opacity-100"
              leave-active-class="transition duration-75 ease-in"
              leave-from-class="transform scale-100 opacity-100"
              leave-to-class="transform scale-95 opacity-0"
            >
              <MenuItems
                class="absolute right-10 mt-0 origin-top-right bg-white divide-y divide-gray-100 shadow-lg focus:outline-none"
                style="border-radius: 20px; width: 168px; padding: 2px 2px;"
              >
                <div class="border-4 border-blue" style="border-radius: 20px;">
                  <MenuItem v-slot="{ active }">
                    <button
                      :class="[
                        active ? 'bg-blue-lightest text-blue' : 'text-gray-900',
                        'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                      ]"
                      @click.stop="downloadActivity(item.id)"
                    >
                      <div class="flex flex-row items-center">
                        <DownloadIcn
                          fill-rule="evenodd"
                          class="mr-1 blue-icon"
                          width="20px"
                          height="20px"
                        />
                        <span class="text-blue text-lg">印刷データ</span>
                      </div>
                    </button>
                  </MenuItem>
                  <hr class="border-dotted border-blue" />
                  <MenuItem
                    v-slot="{ active }"
                    class="text-blue disabled:bg-black-lightest disabled:text-white"
                    style="border-radius: 0px 0px 16px 16px;"
                    :disabled="!deleteFlag"
                  >
                    <button
                      @click="deleteBtnClicked(item)"
                      :class="[
                        active ? 'bg-blue-lightest text-blue' : 'text-gray-900',
                        'group flex rounded-md items-center w-full px-2 py-2 text-sm',
                      ]"
                    >
                      <div class="flex flex-row items-center">
                        <TrashIcn
                          fill-rule="evenodd"
                          class="mr-1 blue-icon"
                          width="20px"
                          height="20px"
                        />
                        <span class="text-blue text-lg">削除</span>
                      </div>
                    </button>
                  </MenuItem>
                </div>
              </MenuItems>
            </transition>
          </Menu>
        </td>
      </tr>
    </template>
  </app-table>
  <AppConfirm color="blue" />
</template>

<script>
import { ref, watch, computed, onMounted, reactive } from 'vue'

import { Menu, MenuButton, MenuItems, MenuItem } from '@headlessui/vue'
import AppTable from '@/components/ui/AppTable'
import AppDocumentStatusIndicatorProvider from '@/components/provider/AppDocumentStatusIndicatorProvider'

// import RejectedIcn from "@/assets/icons/rejected.svg?inline";
import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import ActionsIcn from '@/assets/icons/actions.svg?inline'

import AppConfirm from '@/components/ui/AppConfirm'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useCurrentUser } from '@/services/useCurrentUser'

import { useConfirmation } from '@/services/useConfirmation'
import TrashIcn from '@/assets/icons/trash.svg?inline'
import DownloadIcn from '@/assets/icons/download.svg?inline'
import { useKeywordSearch } from '@/services/useKeywordSearch'
import { useDenominationSelect } from '@/services/useDenominationSelect'
import { useInputSelectSearch } from '@/services/useInputSelectSearch'
import { useYearSelector } from '@/services/useYearSelector'

export default {
  name: 'ActivitiesTable_TODA',

  components: {
    AppTable,
    UserCircleIcn,
    ActionsIcn,
    Menu,
    MenuButton,
    MenuItems,
    MenuItem,
    AppConfirm,
    TrashIcn,
    DownloadIcn,
    AppDocumentStatusIndicatorProvider,
  },

  setup() {
    const count = ref(12)
    const deleteFlag = ref(false)
    const { keyword } = useKeywordSearch()
    const { selectedDenomination } = useDenominationSelect()
    const { isInput } = useInputSelectSearch()
    const { getActivities } = usePoliticalActions()
    const { currentYear } = useYearSelector()

    let acitiveItem = reactive()

    const {
      activities: items,
      filteredStatus,
      isReversedSort,
      deleteActivity,
    } = usePoliticalActions()
    const { currentUser } = useCurrentUser()
    const { toggleShowConfirmation, isConfirmed } = useConfirmation()

    onMounted(async () => {
      await getActivities(currentYear.value)

      filteredStatus.value = [] // reset filtered status
    })

    const deleteBtnClicked = item => {
      acitiveItem = item
      toggleShowConfirmation(true)
    }

    const deleteApproval = () => {
      deleteFlag.value = true

      if (currentUser.role_id !== 1) {
        deleteFlag.value = false
        return
      } else {
        return
      }
    }

    const deleteItem = () => {
      deleteActivity(acitiveItem.id)
      toggleShowConfirmation(false)
    }

    watch(isConfirmed, isConfirmed => {
      if (isConfirmed) deleteItem()
    })

    const filteredActivitiesBySelect = computed(() => {
      if (isReversedSort && isReversedSort.value == true) {
        return filterByStatus(filterByDenomination(items.value)).reverse()
      } else {
        return filterByStatus(filterByDenomination(items.value))
      }
    })

    const filterByDenomination = items => {
      return items.filter(
        item =>
          selectedDenomination.value == 0 ||
          item.user.denominationId == selectedDenomination.value.denominationId,
      )
    }

    const filteredItems = computed(() => {
      if (isReversedSort && isReversedSort.value == true) {
        return filterByStatus(filterByKeyword(items.value)).reverse()
      }
      return filterByStatus(filterByKeyword(items.value))
    })

    const filterByKeyword = actions => {
      if (keyword.value.length == 0) {
        return actions
      }
      return actions.filter(
        item =>
          (item['purpose'] && item['purpose'].includes(keyword.value)) ||
          (item['place'] && item['place'].includes(keyword.value)),
      )
    }

    const filterByStatus = actions => {
      if (filteredStatus.value.length) {
        return actions.filter(
          item =>
            filteredStatus.value.includes(item.documents[0].option.viewType) ||
            filteredStatus.value.includes(item.documents[1].option.viewType) ||
            filteredStatus.value.includes(item.documents[2].option.viewType),
        )
      }
      return actions
    }

    return {
      acitiveItem,
      deleteApproval,
      deleteItem,
      deleteFlag,
      currentUser,
      count,
      items,
      keyword,
      deleteBtnClicked,
      filteredItems,
      filterByDenomination,
      filteredActivitiesBySelect,
      isInput,
      ...usePoliticalActions(),
    }
  },
}
</script>
